import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';

@Component({
  selector: 'zui-tip-card',
  templateUrl: './tip-card.component.html',
  styleUrls: [ './tip-card.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule
  ]
})
export class ZuiTipCardComponent {
  icon = input<string | null>('tips_and_updates');
  iconAlignment = input<'start' | 'end'>('start');
  theme = input<'tip' | 'warning'>('tip');
  spacing = input<number>(24);
  iconSpacing = input<number>(120);

  // -- Data
  iconStartPosition = computed(() => this.iconAlignment() === 'start')
  iconEndPosition = computed(() => this.iconAlignment() === 'end')
}
